module.exports = __webpack_public_path__ + "img/Evaporator.5b78abfc.png";